<div *ngIf="account.state.reason?.length" class="state-reason d-flex align-items-center" [ngClass]="'state-reason--' + variant">
  <span>{{ ('INTEGRATION_DIALOG.STATES.' + account.state.reason?.[0]) | translate }}</span>
  <core-icon [icon]="icon" size="xxs" class="ml-1"></core-icon>
</div>
